// @flow
import * as React from 'react';
import Icon from '../../../components/shared/Icons/Icon';
import styles from './styles';

type Props = {
  label: string,
  verticalName: VerticalName,
  onFilterTagRemove: Function,
};

function FilterTag({ label, verticalName, onFilterTagRemove }: Props): ?React.Node {
  return (
    <li className={`filter-tag-item ${verticalName}`}>
      <p> {label}</p>

      <div className="icon-wrapper">
        <Icon
          className={`close ${verticalName}`}
          type="close"
          width={20}
          fill="#1cd366"
          onClick={onFilterTagRemove}
        />
      </div>

      <style jsx> {styles} </style>
    </li>
  );
}

FilterTag.defaultProps = {
  title: null,
  value: null,
};

export default FilterTag;



// WEBPACK FOOTER //
// ./app/common/FilterTags/item/index.js